import { Injectable } from '@angular/core';
import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { ConfigService } from '../config.service';
import { ClienteModel } from '../../models/cliente/cliente.model';
import { id } from '@swimlane/ngx-datatable';// SC ver si hace falta
import { ClienteDomicilioModel } from '../../models/cliente/clienteDomicilio.model';
import { ClienteContactoModel } from '../../models/cliente/clienteContacto.model'

@Injectable({
  providedIn: 'root'
})
export class ClienteService {

  private baseUrl = this.configService.config.servidor?.api_server;
  constructor(private http:HttpClient, private configService: ConfigService) { }

  // SC CARFER-11 Se define para obtener los datos del cliente dado su id.
  getCliente(id_cliente: number){
    // const url = `${this.baseUrl}/Cliente/${id_cliente}`;
    // MC CATFER-94 Uso las referencias al archivo resource.json
    const url = this.baseUrl + this.configService.resource.CLIENTE.GET_CLIENTE.VERSION + this.configService.resource.CLIENTE.PATH_BASE + this.configService.resource.CLIENTE.GET_CLIENTE.PATH_REL.replace('{id_cliente}', id_cliente);
    return this.http.get<ClienteModel>(url);
  }

  patchCliente(id_cliente: number, cliente: any ){
    // const url = `${this.baseUrl}/Cliente/${id_cliente}`;
    // MC CATFER-94 Uso las referencias al archivo resource.json
    const url = this.baseUrl + this.configService.resource.CLIENTE.PATCH_CLIENTE.VERSION + this.configService.resource.CLIENTE.PATH_BASE + this.configService.resource.CLIENTE.PATCH_CLIENTE.PATH_REL.replace('{id_cliente}', id_cliente)
    return this.http.patch<ClienteModel>(url, cliente);
  }

  getDomicilios(id_cliente:number){
    // const url = `${this.baseUrl}/ClienteDomicilio`;
    // MC CATFER-94 Uso las referencias al archivo resource.json
    const url = this.baseUrl + this.configService.resource.CLIENTE_DOMICILIO.VERSION + this.configService.resource.CLIENTE_DOMICILIO.PATH_BASE;
    let params = {};
    Object.assign(params, {idCliente: id_cliente});
    const httpParams = params;
    return this.http.get<ClienteDomicilioModel>(url, {params:httpParams});
  }

  getContactos(id_cliente:number){
    // const url = `${this.baseUrl}/ClienteLibretaContacto`;
    // MC CATFER-94 Uso las referencias al archivo resource.json
    const url = this.baseUrl + this.configService.resource.CLIENTE_LIBRETA_CONTACTO.VERSION + this.configService.resource.CLIENTE_LIBRETA_CONTACTO.PATH_BASE;
    let params = {};
    Object.assign(params, {idCliente: id_cliente});
    const httpParams = params;
    return this.http.get<ClienteContactoModel>(url, {params:httpParams});
  }
}
